<template>
  <div style="height: 100%">

    <div class="back-box" @click="goBack">
      <img src="@/assets/new/right.png" alt=""/>
      <span>物联网平台</span>
    </div>

    <el-scrollbar style="height: calc(100vh - 108px);">
      <el-menu
        style="border:none;"
        :default-active="activeMenu"
        :collapse="false"
        :background-color="'#f5f5f5'"
        :text-color="'#555555'"
        :unique-opened="true"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="(route, index) in constantRoutes" :key="route.path + index" :item="route" :base-path="route.path"/>
      </el-menu>
    </el-scrollbar>

  </div>
</template>

<script>
import {constantRoutes} from '@/router';

import Logo from './Logo';
import SidebarItem from './SidebarItem';

export default {
  components: {SidebarItem, Logo},
  computed: {
    activeMenu(){
      const route = this.$route;
      const {meta, path} = route;
      if (meta['activeMenu']) {
        return meta['activeMenu'];
      }
      return path;
    },
  },
  data(){
    return {
      constantRoutes: constantRoutes,
    };
  },
  mounted(){
  },
  methods: {
    goBack(){
      this.$router.push({path: '/home'});
    },
  },
};
</script>

<style lang="scss" scoped>
.back-box {
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 58px;
  font-size: 14px;
  border-bottom: 1px solid #dedede;
  padding: 12px 13px 12px 20px;

  img {
    width: 14px;
    height: 14px;
    margin-right: 7px;
  }

  span {
    font-weight: 600;
    font-size: 14px;
    color: #333333;
    line-height: 15px;
    font-style: normal;
  }
}

::v-deep {

  .el-submenu .is-active,.el-menu-item.is-active{
    color:#333 !important;
    background:  #dedede !important;
  }
  .el-submenu__title,.el-menu-item {
    height: 42px;
    line-height: 42px;
    font-weight: bold;
  }
}
</style>
